var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaskLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1146,
    height: 1147,
    viewBox: "0 0 1146 1147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M378.587 2.0379C381.048 -0.398059 385.012 -0.398047 387.474 2.03792L762.653 373.32C766.664 377.29 763.853 384.128 758.209 384.128H7.85075C2.20691 384.128 -0.604283 377.29 3.40729 373.32L378.587 2.0379Z",
    fill: "#A60A39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1143.79 760.409C1146.23 762.871 1146.23 766.835 1143.79 769.296L772.508 1144.48C768.538 1148.49 761.701 1145.68 761.701 1140.03L761.701 389.673C761.701 384.03 768.538 381.218 772.508 385.23L1143.79 760.409Z",
    fill: "#A60A39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M379.563 0.000551666C387.232 -0.00442521 387.264 0.0259097 396.722 0.0259097H1128.87C1138.33 0.0259097 1145.99 7.69359 1145.99 17.1521V750.02C1145.99 759.478 1138.33 767.146 1128.87 767.146H396.722C387.264 767.146 379.563 759.471 379.563 750.013V0.000551666Z",
    fill: "#ED155A"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_485",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 379,
    y: 0,
    width: 767,
    height: 768
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1146 750.004C1146 759.463 1146 757.651 1146 767.133L396.728 767.131C387.269 767.131 379.602 759.463 379.602 750.004L379.601 17.1379C379.601 7.67933 387.269 0.0116355 396.728 0.0116347L1128.87 0.0115706C1138.33 0.0115698 1146 7.67926 1146 17.1378L1146 750.004Z",
    fill: "#ED155A"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1715.77 219.564C1722.46 226.255 1722.46 237.104 1715.77 243.795L481.669 1479.06C474.984 1485.75 464.146 1485.75 457.461 1479.06L75.0167 1096.26C68.3316 1089.56 68.3315 1078.72 75.0166 1072.02L1309.12 -163.241C1315.8 -169.932 1326.64 -169.932 1333.33 -163.241L1715.77 219.564Z",
    fill: "#D0124F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M994.15 288.026C994.15 362.559 933.728 422.981 859.194 422.981C784.661 422.981 724.239 362.559 724.239 288.026C724.239 213.492 784.661 153.07 859.194 153.07C933.728 153.07 994.15 213.492 994.15 288.026Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.777 914.093L0.70078 1060.93C0.252727 1061.36 0 1061.96 0 1062.59V1143.58C0 1144.86 1.03765 1145.89 2.31765 1145.89H77.8668C78.4655 1145.89 79.041 1145.66 79.4726 1145.25L233.781 997.239C234.712 996.346 234.732 994.866 233.826 993.948L155.045 914.127C154.15 913.221 152.69 913.206 151.777 914.093Z",
    fill: "#A60A39"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144.012 536.627L1.85721 675.68C1.44366 676.084 1.21094 676.636 1.21094 677.211V825.094C1.21094 827.002 3.53244 827.968 4.91054 826.634L225.189 613.373C224.405 612.566 224.519 612.678 223.657 611.832L145.85 534.859C144.765 535.873 144.862 535.796 144.012 536.627Z",
    fill: "#A60A39"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M533.921 922.289L308.967 1141.05C307.574 1142.41 308.525 1144.78 310.462 1144.78H465.901C466.469 1144.78 467.013 1144.56 467.416 1144.15L611.428 1000.45C610.657 999.655 610.752 999.751 609.909 998.901L535.441 923.811C534.611 922.974 534.654 923 533.921 922.289Z",
    fill: "#A60A39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaskLogo);
export default __webpack_public_path__ + "static/media/mask-logo.fee9c1b2603f02e18c0d8257ae131b76.svg";
export { ForwardRef as ReactComponent };